module.exports = __webpack_public_path__ + "img/front_7.3e236d2d.svg";